import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ws, setWs] = useState(null);
  const [version, setVersion] = useState(0);

  const refreshWs = useCallback(async () => {
    const { data } = await api.get("/workspace");
    setWs(data);
    setUser((u) => (u ? { ...u, ...data } : u));
    return data;
  }, []);

  useEffect(() => {
    api.get("/auth/me")
      .then(({ data }) => { setUser(data.user); return refreshWs(); })
      .catch(() => setUser(false));
  }, [refreshWs]);

  useEffect(() => {
    const onUnauth = () => {
      sessionStorage.removeItem("jt_token");
      setUser((u) => {
        if (u) toast.error("Sesi Anda berakhir. Silakan masuk kembali.");
        return false;
      });
    };
    window.addEventListener("jt-unauth", onUnauth);
    return () => window.removeEventListener("jt-unauth", onUnauth);
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    sessionStorage.setItem("jt_token", data.token);
    setUser(data.user);
    await refreshWs();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* session cleared locally anyway */ }
    sessionStorage.removeItem("jt_token");
    setUser(false);
    setWs(null);
  };

  const bump = useCallback(async () => {
    setVersion((v) => v + 1);
    await refreshWs();
  }, [refreshWs]);

  return (
    <AuthCtx.Provider value={{ user, ws, login, logout, refreshWs, version, bump }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
